import { NoteIcon } from '@/components/icons';
import { useNote } from '@/context/NoteProvider';
import { Box, Grid2, Typography } from '@mui/material';
import EmptyState from './EmptyState';
import ErrorState from './ErrorState';
import LoadingState from './LoadingState';
import NoteDisplay from './NoteDisplay';
import { rightPanelStyles } from './styles';

const PortalRightPanel = () => {
  const noteContext = useNote();

  // Only show error when the SESSION context is in error state
  const noteError = noteContext.sessionStatus === 'error';
  const shouldShowLoading = noteContext.isSessionLoading;
  const showNote = noteContext.isSessionCompleted && !!noteContext.sessionNote;
  const sessionErrorMessage =
    noteError
      ? noteContext.error ??
        'Unable to process audio: The recording appears to be silent or corrupted. Please record a new audio file with clear speech.'
      : undefined;

  return (
    <Grid2 size={{ xs: 12, lg: 6 }} sx={rightPanelStyles.container}>
      <Box sx={rightPanelStyles.card}>
        {!shouldShowLoading && !showNote && (
          <Box sx={rightPanelStyles.header}>
            <Box sx={rightPanelStyles.iconContainer}>
              <NoteIcon width={28} height={28} />
            </Box>
            <Typography variant="h4" sx={rightPanelStyles.headerTitle}>
              Generated notes
            </Typography>
          </Box>
        )}
        {/* Loading State */}
        {shouldShowLoading && <LoadingState />}

        {/* Error State */}
        {noteError && <ErrorState message={sessionErrorMessage} />}

        {/* Note Display - Show SESSION note */}
        {showNote && !shouldShowLoading && (
          <NoteDisplay noteToDisplay={noteContext.sessionNote} />
        )}

        {/* Empty State */}
        {!showNote && !shouldShowLoading && !noteError && <EmptyState />}
      </Box>
    </Grid2>
  );
};

export default PortalRightPanel;
